import { ErrorInfo, DiagsState } from './store'
import { LOGIN_RECEIVED } from '../../auth/store/reducers'
import { ShowConfirmParams } from './actions'

export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'
export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'
export const LOG_ERROR = 'LOG_ERROR'

export type DiagsAction =
  | { type: typeof SHOW_ALERT, title: string, text: string }
  | { type: typeof HIDE_ALERT }
  | { type: typeof SHOW_CONFIRM, showConfirmParams: ShowConfirmParams}
  | { type: typeof HIDE_CONFIRM }
  | { type: typeof LOG_ERROR, errorInfo: ErrorInfo }
  | { type: typeof LOGIN_RECEIVED }

export function diagsReducer(state: DiagsState, action: DiagsAction) {
  switch (action.type) {
    case SHOW_ALERT: {
      return {
        ...state,
        alert: {
          open: true,
          title: action.title,
          text: action.text
        }
      }
    }

    case HIDE_ALERT: {
      return {
        ...state,
        alert: {
          open: false,
          title: '',
          text: ''
        }
      }
    }


    case SHOW_CONFIRM: {
      return {
        ...state,
        confirm: {
          open: true,
          title: action.showConfirmParams.title,
          text: action.showConfirmParams.text,
          callback: action.showConfirmParams.callback
        }
      }
    }

    case HIDE_CONFIRM: {
      return {
        ...state,
        confirm: {
          open: false,
          title: '',
          text: '',
          callback: null
        }
      }
    }
    

    case LOG_ERROR: {
      return {
        ...state,
        lastError: action.errorInfo,
        lastErrorHandled: false
      }
    }

    case LOGIN_RECEIVED: {
      return {
        ...state,
        appLoading: false
      }
    }

    default: {
      return state
    }
  }
}
